import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-person-leave-detail',
  templateUrl: './person-leave-detail.component.html',
  styleUrls: ['./person-leave-detail.component.scss']
})
export class PersonLeaveDetailComponent implements OnInit {
  @Input() row;
  constructor(public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    console.log(this.row);
  }

  getByDate(createdAt?: string, updateAt?: string) {
    const defaultValue = '0001-01-01T00:00:00';

    const validDate = updateAt !== defaultValue
      ? updateAt
      : createdAt !== defaultValue
        ? createdAt
        : null;

    return validDate
      ? new Date(validDate).toLocaleString('tr-TR')
      : '';
  }

  closeModal() {
    this.activeModal.close();
  }

}
